<template>
    <li v-if="cart" class="h-cart">
        <inertia-link class="cart-contents" href="/cart">
            <p class="h-cart-icon">
                <i class="ion-android-cart"></i>
                <span>{{ numberItems }}</span>
            </p>
            <p class="h-cart-total">${{ cart.total }}</p>
        </inertia-link>
        <div class="widget_shopping_cart">
            <div class="widget_shopping_cart_content">
                <ul class="cart_list">
                    <li v-for="item in cart.details" :key="item.id">
                        <a @click.prevent="removeItem(item)" href="#" class="remove">
                            <i v-show="removingItem == item" class="fa fa-spinner fa-spin"></i>
                            <i v-show="removingItem != item" class="fa fa-times"></i>
                        </a>
                        <a href="#" style="padding-left: 5px;">
                            <!-- <img src="http://placehold.it/100x67" alt=""> -->
                            {{ item.name }}
                        </a>
                        <span class="quantity">{{ item.qty }} &times; ${{ item.price }}</span>
                    </li>
                </ul>

                <p v-show="$page.config.taxes.iva.show" class="total"><b>Subtotal:</b> ${{ cart.subtotal }}</p>
                <p class="total"><b>Total:</b> ${{ cart.total }}</p>
                <p class="buttons text-center">
                    <inertia-link href="/cart" class="button">Ver el carrito</inertia-link>
                    <!-- <a href="checkout.html" class="button">Ordenar</a> -->
                </p>
            </div>
        </div>
    </li>
</template>

<script>
export default {

    data() {
        return {
            cart: _.cloneDeep(this.$page.cart),

            removingItem: null,
        };
    },

    methods: {

        removeItem(item) {
            this.removingItem = item;
            this.$inertia.delete(`/cart/${item.rowId}`);
        },
    },

    computed: {
        numberItems() {
            return Object.keys(this.cart.details).length;
        },
    },
}
</script>
